// eslint-disable-next-line import/prefer-default-export
export const POSTPONED_NEWS_LS_KEY = 'postponedNewsIds';
